// Shown by App.tsx when the root /api/me query settles with a NON-401
// error (5xx / network) — i.e. the backend is briefly unreachable, not
// "you're logged out". Distinct from Login so a transient blip during the
// post-login boot doesn't masquerade as a logout. Always offers an escape
// hatch (retry + full reload) so a persistent failure never traps the user.

import { Button } from './ui/button.js';

export function ReconnectingScreen({ onRetry }: { onRetry: () => void }) {
  return (
    <main className="flex min-h-screen flex-col items-center justify-center gap-4 bg-background px-6 text-center">
      <h1 className="text-lg font-semibold text-foreground">
        Can&rsquo;t reach the server
      </h1>
      <p className="max-w-sm text-sm text-muted-foreground">
        We&rsquo;re having trouble connecting. This is usually temporary, and
        your session is still active &mdash; try again in a moment.
      </p>
      <div className="flex gap-3">
        <Button onClick={onRetry}>Try again</Button>
        <Button variant="outline" onClick={() => window.location.reload()}>
          Reload page
        </Button>
      </div>
    </main>
  );
}
